<div
    class="line-wrapper"
    [id]="form.displayId()"
    [style.--line-wrapper-margin]="wrapperMargin()"
    [style.--line-color]="lineColor()"
    [style.--line-style]="lineStyle()"
    [style.--line-thickness]="lineThickness()"
    [style.--line-size]="lineSize()"
    [style.--line-margin-left]="marginLeft()"
    [style.--line-margin-right]="marginRight()"
>
    @if (isDottedSafari()) {
        <div class="line-safari"></div>
    } @else {
        <hr class="line" />
    }
</div>
